import type { User } from './user'

export type SubscriptionType = 'anonymous' | 'free' | 'premium'

export const getSubscriptionType = (user: User): SubscriptionType => {
  if (user.isAnonymous) {
    return 'anonymous'
  }
  if (user.isPremium) {
    return 'premium'
  }
  return 'free'
}
